var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeraConfirm',_vm._g(_vm._b({},'HeraConfirm',{
    title: _vm.title,
    text: _vm.text,
    cancelButtonText: _vm.cancelButtonText,
    confirmButtonText: _vm.confirmButtonText,
    isLoading: _vm.isLoading,
  },false),_vm.$listeners),[_c('TournamentSharingSettings',{staticClass:"mt-4",attrs:{"social-networks":_vm.connectedSocials}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }